import EFOcats_logic from '../efocats_logic.js';

/**
 * 処理のパターン化の親クラス
 */
export default class EFOcats_pattern_core extends EFOcats_logic {
  /**
   * コンストラクタ
   * パターンの可変部分の設定を受け取り、自身のインスタンスを各処理に通知する
   * @param {*} opt 可変部分の設定
   */
  constructor(opt) {
    super();
    this.opt = opt;
  }

  /**
   * 読み込んだフォームをページごとに分割する
   * @param {*} form 読み込んだフォームのHTMLElement
   * @param {*} pages coreで生成されたページ一覧
   * @returns ページ一覧
   */
  get_pages(form, pages) {
    return pages;
  }

  /**
   * テンプレート名を取得する
   * @param {*} page ページのHTMLELement
   * @param {*} tpl coreで取得したテンプレート名
   * @return テンプレート名
   */
  get_tpl(page, tpl) {
    return tpl;
  }

  /**
   * ページから入力欄を取り出す
   * @param {*} page ページのHTMLElement
   * @param {*} inputs coreで取得した入力欄の配列
   * @returns 入力欄の配列
   */
  get_inputs(page, inputs) {
    return inputs;
  }

  /**
   * 入力欄の属性を設定する
   * @param {*} page
   * @param {*} inputs
   * @param {*} index
   * @param {*} tempanswer
   */
  get_attr(page, inputs, index, tempanswer) {}

  /**
   * ページデータの拡張
   * @param {*} page
   * @param {*} temp
   */
  pagedata_extend(page, temp) {}
}
